/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {accounting} from 'accounting'
import Page from '../Pagination/Pagination'

class DetailsBasket extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      rows: []
    }
  }

  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    const token = sessionStorage.getItem('accessToken')
    http
      .get(`report/dispatch/deliveryPack/individual?export=false&pageSize=10&pageNumber=1`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            rows: response.data.object.result,
            lengthrows: response.data.object.countAll
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  onResultFetched(data) {
    this.setState({
      rows: data
    })
  }

  render() {
    const {lengthrows} = this.state
    let pageNumber = sessionStorage.getItem('pageNumber')
    return (
      <div className="rtl printA4Page">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <table className="baseTable">
            <tbody>
              <tr className="firstRow">
                <td>ردیف</td>
                <td>نام خریدار</td>
                <td>نام تحویل گیرنده</td>
                <td>آدرس</td>
                <td>موبایل</td>
                <td>تلفن</td>
                <td>وضعیت پرداخت</td>
                <td>شیوه ارسال</td>
                <td>پرداخت در محل</td>
                <td className="priceCell">جمع کل</td>
                <td className="priceCell">تخفیف</td>
                <td className="priceCell">قابل پرداخت</td>
              </tr>
              {this.state.rows.map((items, index) => (
                <tr key={index}>
                  <td>{(pageNumber - 1) * 10 + index + 1}</td>
                  <td>{items.buyerName}</td>
                  <td>{items.recipientName}</td>
                  <td>{items.address}</td>
                  <td>{items.mobile}</td>
                  <td>{items.phone}</td>
                  <td>{items.paid ? 'پرداخت شده' : 'پرداخت نشده'}</td>
                  <td>{items.deliveryMethodTitle}</td>
                  <td>{items.payOnDelivery ? 'بله' : 'خیر'}</td>
                  <td className="priceCell">{accounting.formatMoney(items.totalAmount, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(items.discountAmount, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(items.payableAmount, '', ',')}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="paginationWrapp">
            <Page
              defaultCurrent={1}
              total={lengthrows}
              onResultFetched={this.onResultFetched.bind(this)}
              url="report/dispatch/deliveryPack/individual"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default DetailsBasket
